import React from "react";
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import Competitor from "components/presentation/Competitor";
import Noc from 'components/presentation/Noc';
import Gates from 'components/sports/csl/events/team/Gates';
import SportCode from "components/common/SportCode"
import Stack from 'react-bootstrap/Stack';

const Current = ({data} ) => {
  const { breakPoint } = useViewport();

  let currents = data?.results?.currentExtendedInfos.filter(cei => cei.ei_code === 'CURRENT')

  return(
    <>
      <h4><Label data={currents && currents.length > 1 ? 'LabelCurrentCompetitors' : 'LabelCurrentCompetitor'} /></h4> 
      {
        currents?.map(current => {
          let row = data?.results?.items?.find(i => i?.participant?.code === current.ei_value) 
          
          return(
            <>
          
            <table className="table table-bordered" key={`current-${row?.participant?.code}`}>
              <thead>
                <tr className="d-none d-md-table-row">
                  <th className="text-right w-5"><Label data="LabelStartOrder" /></th>
                  <th className="text-left"><Label data="HeaderName" /></th>
                  <th className="text-right"><Label data="HeaderTime" /></th>
                  <th className="text-right"><Label data="HeaderRank" /></th>
                </tr>
                <tr className="d-table-row d-md-none" >
                  <th colSpan="3"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-right">{row?.startOrder}</td>
                  <td className="text-left">
                    <div className="d-flex align-items-center">
                      <div className="d-none d-md-inline"><Noc {...row?.participant?.organisation} /></div>
                      <Competitor {...row?.participant} hideNoc={false} hidePicture={true}/>
                    </div>
                  </td>
                  <td className="text-right d-none d-md-table-cell">
                    {row?.resultType === 'IRM'
                      ? <SportCode code={row?.resultIrm} discipline="CSL" entity="@IRM" />
                      : row?.resultData
                    }
                  </td>
                  <td className="text-right d-none d-md-table-cell">
                    {row?.resultType === 'IRM'
                        ? ''
                        : row?.resultRank
                    }
                  </td>
                  <td className="d-table-cell d-md-none">
                    <Stack direction="vertical">
                      <Stack direction="horizontal">
                        <strong><Label data="HeaderTime" />:&nbsp;</strong>
                        {row?.resultType === 'IRM'
                          ? <SportCode code={row?.resultIrm} discipline="CSL" entity="@IRM" />
                          : row?.resultData
                        }                         
                      </Stack>
                      <Stack direction="horizontal">
                        <strong><Label data="LabelRank" />:&nbsp;</strong>
                        {row?.resultType === 'IRM'
                            ? ''
                            : row?.resultRank
                        }
                      </Stack>
                    </Stack>
                  </td>
                </tr>
              </tbody>
            </table>
            <Gates config={data?.config} row={row} />
            </>
          )
        })
      }
    </>
  )
}
 
export default Current;